<template>
  <a-drawer placement="right" :closable="true" :visible="!hidden" :width="drawerWidth" :destroyOnClose="true"
    :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">
    <template #title>
      <b>研发成果应用</b>
    </template>
    <a-input-search v-model="keywrod" placeholder="输入研发成果关键词" enter-button="研发成果查询" size="large" allowClear
      @search="onSearch" />
    <a-radio-group v-model="returnDataType" :options="radioboxOptions" @change="onRadioBoxChange" />
    <a-table :columns="columns" :data-source="list" :loading="tableLoading" :pagination="pagination" size="middle"
      row-key="id" :row-selection="rowSelection">
      <template slot="main" slot-scope="text, record">
        <div style="font-size: 14px;">
          <div style="position: relative;">
            <a :href="record.url" target="_blank" style="text-decoration: underline;" @click="viewDetail(record)">{{
              record.name }}</a>
            <a-tooltip v-if="record.isRelate === 0" placement="topLeft" title="绑定研发成果与配方" arrow-point-at-center
              style="position: absolute;right: 40px;top: 0;">
              <a-button size="large" type="primary" ghost @click="relateRMP(record)">确认应用</a-button>
            </a-tooltip>
            <a-tooltip v-else placement="topLeft" title="取消研发成果与配方的绑定关系" arrow-point-at-center
              style="position: absolute;right: 40px;top: 0;">
              <a-button size="large" type="danger" ghost @click="unRelateRMP(record)">取消应用</a-button>
            </a-tooltip>
          </div>
          <div>
            <label style="margin-right: 1.5em;">成果编号：{{ record.no }}</label>
            <label>发布日期：{{ record.publishTime }}</label>
          </div>
          <div style="display: flex;align-items: center;">
            <div style="flex: 0;white-space: nowrap">落地应用方案：</div>
            <div v-html="record.abstractContent" class="ellipsis"></div>
          </div>
        </div>
      </template>
    </a-table>

    <RMP-result-detail-drawer :visible="detailDrawerVisible" :result="detailDrawerObject"
      @close="onDetailDrawerClose" />
  </a-drawer>
</template>

<script>
import { nhfMixins } from '../untils';
import RMPResultDetailDrawer from '../components/RMPResultDetailDrawer.vue';
export default {
  props: {
    hidden: {
      type: Boolean,
      default: false
    },
    fid: {
      type: String,
      default: ''
    }
  },
  mixins: [nhfMixins],
  components: {
    RMPResultDetailDrawer
  },
  data() {
    return {
      wrapStyle: {
        overflow: 'hidden'
      },
      bodyStyle: {
        padding: '10px',
        textAlign: 'center',
        overflow: 'hidden',
      },
      drawerWidth: 1200,
      radioboxOptions: [
        { label: '全部研发成果', value: 0 },
        { label: '已应用研发成果', value: 1 },
        { label: '未应用研发成果', value: 2 },
      ],
      keywrod: '',
      returnDataType: 0,
      list: [],
      tableLoading: false,
      columns: [{ title: '', dataIndex: '', scopedSlots: { customRender: 'main' }, }],
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.pagination.pageSize = pageSize;
          this.getList();
        }, // 选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
          this.getList({ current: 1, pageSize });
        } //每页多少条
      },
      selectedRowKeys: [],

      detailDrawerVisible: false,
      detailDrawerObject: {},
    };
  },
  mounted() {
    const viewportWidth = window.innerWidth;
    const _width = viewportWidth * 0.8;
    if (_width < 1200) {
      this.drawerWidth = _width;
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: record => {
          return ({
            props: {
              disabled: this.selectedRowKeys.length >= 20 && !this.selectedRowKeys.includes(record.id)
            },
          });
        },
      };
    },
  },
  watch: {
    hidden(val) {
      if (!val) {
        this.getList();
      }
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    getList(pagination) {
      let { current, pageSize } = pagination || this.pagination;
      let params = {
        query: {
          size: pageSize,
          current,
        },
        returnDataType: this.returnDataType,
        keyword: this.keywrod,
        formulaId: this.fid
      };
      this.tableLoading = true;
      this.getFormulaRmpResult(params).then(res => {
        let { success, data } = res || {};
        if (success) {
          let { records, current = 1, total = 0, size = pageSize } = data;
          this.pagination.current = current;
          this.pagination.pageSize = size;
          this.pagination.total = total;
          this.selectedRowKeys = [];
          records.forEach(item => {
            if (item.isRelate === 1)
              this.selectedRowKeys.push(item.id);
            item.abstractContent = item.abstractContent.replace(/<[^>]+>/g, '');
          });
          this.list = records || [];
        }
        this.tableLoading = false;
      });
    },

    onSearch() {
      this.getList();
    },
    onRadioBoxChange(e) {
      this.returnDataType = e.target.value;
      this.getList();
    },
    onSelectChange() { },
    relateRMP(row, unBind) {
      let _bind = true;
      if (unBind) _bind = false;
      this.tableLoading = true;
      this.bindFormulaRmpResult({
        "formulaId": this.fid,
        "isBind": _bind,
        "rmpResultId": row.id
      }).then(res => {
        if (res.success) {
          this.$message.success("操作成功");
          this.list.find(item => item.id === row.id).isRelate = _bind ? 1 : 0;
          this.selectedRowKeys = this.list.filter(item => item.isRelate).map(item => item.id);
          console.log(this.selectedRowKeys);
        } else {
          this.$message.error("操作失败");
        }
        this.tableLoading = false;
      });
    },
    unRelateRMP(row) {
      this.relateRMP(row, true);
    },
    viewDetail(row) {
      this.detailDrawerObject = row;
      this.detailDrawerVisible = true;
    },

    onDetailDrawerClose() {
      this.detailDrawerVisible = false;
      this.detailDrawerObject = {};
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .ant-btn-lg {
  height: 30px;
  padding: 0 15px;
  font-size: 16px;
  border-radius: 4px;
}

::v-deep .ant-table-thead {
  display: none;
}

::v-deep .ant-input-search-large {
  width: 500px;

  .ant-input-lg {
    height: 40px;
    padding: 6px 11px;
    font-size: 16px !important;
  }

  .ant-btn-lg.ant-input-search-button {
    height: 40px;
  }
}

.ant-radio-group {
  width: 100%;
  text-align: center;
  margin: 12px 0;
}

.ellipsis {
  width: 65%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 50em;
}
</style>
